import { render } from "./PreavvisiInvio.vue?vue&type=template&id=0e87758c&scoped=true"
import script from "./PreavvisiInvio.vue?vue&type=script&lang=js"
export * from "./PreavvisiInvio.vue?vue&type=script&lang=js"

import "./PreavvisiInvio.vue?vue&type=style&index=0&id=0e87758c&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e87758c"]])

export default __exports__